import { render, staticRenderFns } from "./TeprosifChatbot.vue?vue&type=template&id=6aa8f7f1&scoped=true"
import script from "./TeprosifChatbot.vue?vue&type=script&lang=js"
export * from "./TeprosifChatbot.vue?vue&type=script&lang=js"
import style0 from "./TeprosifChatbot.vue?vue&type=style&index=0&id=6aa8f7f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa8f7f1",
  null
  
)

export default component.exports